module.exports = __webpack_public_path__ + "img/alxq9.ec840ae6.png";